import { SxProps } from '@mui/material';

export const ModalTitleSx: SxProps = {
  fontWeight: 700,
  lineHeight: '38.4px',
};
